<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة  تقرير مديونيات الشركة   من الي
        <br />
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          تقرير مديونيات الشركة     من الي
          {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-8">
            <div style="float:right;font-size:17px;text-align:right">
      <p>
                <span style="font-weight:bold;"> جميع المديونيات  : </span>
                <span> {{ all_of_total }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> جميع المبيعات : </span>
                <span> {{ all_sales }} </span>
              </p>
      <p>
                <span style="font-weight:bold;">جميع المرتجعات  : </span>
                <span> {{ all_rebacks }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> جميع السدادات : </span>
                <span> {{ all_sadads }} </span>
              </p>
      <p>
                <span style="font-weight:bold;">جميع الخصومات  : </span>
                <span> {{ all_khasms }} </span>
              </p>
 
        
        
            </div>
          </div>
        </div>
        <hr />
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col"> كود العميل</th>
              <th scope="col"> اسم العميل</th>
              <th scope="col">الرصيد الافتتاحي</th>
              <th scope="col">مندوب المبيعات</th>
              <th scope="col">المنطقة</th>
              <th scope="col">المديونية</th>
              <th scope="col">المبيعات</th>
              <th scope="col">المرتجعات</th>
              <th scope="col">السدادات</th>
              <th scope="col">الخصومات</th>
             
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <th scope="row">{{ f.client ? f.client.code : '' }}</th>
              <td>{{ f.client ? f.client.name : '' }}</td>
              <td>{{ f.client ? f.client.rasid_efttahi : '' }}</td>
              <td>{{ f.client && f.client.mandob_sales ? f.client.mandob_sales.name : '' }}</td>
              <td>{{ f.region ? f.client.region.name : '' }}</td>
              <td>{{ f.madionia }}</td>
              <td>{{ f.sales }}</td>
              <td>{{ f.rebacks }}</td>
              <td>{{ f.sadads }}</td>
              <td>{{ f.khasms }}</td>
            
             
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { CompanyMadioniaReport } from "../../config/apiRoute.js";
import { appUrl } from "../../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],

      all_of_total: "",
      all_sales: "",
      all_rebacks: "",
      all_sadads: "",
      all_khasms: "",
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("branch_id", this.$route.query.id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      CompanyMadioniaReport(frmData).then(response => {
        response.data.myArr.length > 0
          ? (this.fatworas = response.data.myArr)
          : (this.fatworas = []);
         this.all_of_total = response.data.all_of_total;
        this.all_sales = response.data.all_sales;
        this.all_rebacks = response.data.all_rebacks;
        this.all_sadads = response.data.all_sadads;
        this.all_khasms = response.data.all_khasms;
        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
